import o from"./well-known-symbol.js";var r=o,a=r("toStringTag"),t={};t[a]="z";var l=String(t)==="[object z]";export{l as default};
